import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  condition: {
    page: 1,
    limit: 10,
    storeNos: []
  },
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  list: [],
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
